export default __webpack_public_path__ + "static/assets/cda1015f26ecf7986b35a90f9b5a5c52.png";